import { NavLink } from 'react-router-dom';

export const NavBar = ({ isOpen, handleClick }) => (
  <nav
    className={[
      'absolute md:static z-40 md:z-auto bg-background w-full md:w-auto md:pr-0 pr-9 md:pb-0 py-9 pt-24 md:py-0 right-0 text-xl font-poppins font-normal flex flex-col md:flex-row items-end justify-center gap-5 md:gap-3 tracking-wide transition-all duration-500 ease-in-out smart:opacity-100',
      isOpen ? 'top-20 opacity-100' : 'top-[-490px] opacity-0',
    ].join(' ')}>
    <NavLink
      className="w-max text-font hover:text-hover leading-7 duration-500 relative after:content-[''] after:invisible after:absolute after:bottom-_6 after:left-0 after:right-0 after:w-0 after:border after:border-borderColor after:duration-300 hover:after:visible hover:after:w-full"
      to="/"
      onClick={handleClick}>
      Main
    </NavLink>
    <NavLink
      className="w-max text-font hover:text-hover leading-7 duration-500 relative after:content-[''] after:invisible after:absolute after:bottom-_6 after:left-0 after:right-0 after:w-0 after:border after:border-borderColor after:duration-300 hover:after:visible hover:after:w-full"
      to="/map"
      onClick={handleClick}>
      Map
    </NavLink>
    <NavLink
      className="w-max text-font hover:text-hover leading-7 duration-500 relative after:content-[''] after:invisible after:absolute after:bottom-_6 after:left-0 after:right-0 after:w-0 after:border after:border-borderColor after:duration-300 hover:after:visible hover:after:w-full"
      to="/catalog"
      onClick={handleClick}>
      Catalogue
    </NavLink>
  </nav>
);
